import { APIv2Api, Configuration } from 'InteractionManager-sdk';
import { getValidOktaAccessToken } from '@/utils/oktaAuth';
import runtimeConfig from '@/utils/runtimeConfig';

// Singleton: Only one instance of InteractionManager exists during app lifetime
export class InteractionManager {
	private _api: APIv2Api | null = null;

	private static instance: InteractionManager;

	private constructor() {
		// Lazy initialization - API will be created on first access
	}

	public get API(): APIv2Api {
		if (!this._api) {
			const config = new Configuration({
				basePath: runtimeConfig.apiEndpoint,
				apiKey: async () => {
					// getValidOktaAccessToken already dispatches okta-token-expired
					// when the token is missing or expired — do NOT dispatch again
					// here to avoid infinite event loops.
					const token = await getValidOktaAccessToken();
					if (!token) return `Bearer `;
					return `Bearer ${token}`;
				},
				middleware: [
					{
						post: async ({ response }) => {
							if (response.status === 401) {
								window.dispatchEvent(new Event('okta-token-expired'));
							}
							if (
								response.status === 502 ||
								response.status === 503 ||
								response.status === 504
							) {
								window.dispatchEvent(new CustomEvent('backend-unavailable'));
							}
							return response;
						},
						onError: async ({ error }) => {
							// Covers CORS blocks, DNS failures, server unreachable, network timeouts
							window.dispatchEvent(new CustomEvent('backend-unavailable'));
							throw error;
						},
					},
				],
			});
			this._api = new APIv2Api(config);
		}
		return this._api;
	}

	public static getInstance(): InteractionManager {
		if (!InteractionManager.instance) {
			InteractionManager.instance = new InteractionManager();
		}
		return InteractionManager.instance;
	}
}
